import { axiosPost } from "../../react_axios/Axios";
import { VERIFY_LOGIN_ACTION_TYPE, verifyLoginUrl, } from "../../utils/constants";

export const verifyLogin_action = (Email, Password) => async (dispatch) => {
  try {
    const mapdata = {
      Email: Email,
      Password: Password,
    };

    const res = await axiosPost(verifyLoginUrl, mapdata);
    dispatch({
      type: VERIFY_LOGIN_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};
